import NoteRegister from "../AdjustmentNotes/NoteRegister";
import "./debitDesign.css";
export default function DebitNote() {
  return <NoteRegister />;
}
